import { Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import AdminMenu from './AdminMenu';
import { useHasPermission } from '../contexts/AbpPermissionsContext';
import { AbpPermissions } from '../constants/permissions';
import Logo from './common/Logo';
import { useAppName, useAppLogoUrl } from '../hooks/useTenantBranding';
import { LanguagePicker } from '../i18n/LanguagePicker';
import { InstallButton } from './pwa/InstallButton';
import { useTranslation } from '../i18n/useTranslation';

export default function Header() {
  const { t } = useTranslation();
  const auth = useAuth();
  const hasReadPermission = useHasPermission(AbpPermissions.ReadBook);
  const appName = useAppName();
  const appLogoUrl = useAppLogoUrl();

  const handleLogin = () => {
    void auth.signinRedirect();
  };

  const handleLogout = () => {
    void auth.signoutRedirect();
  };

  return (
    <header className="bg-white shadow-sm">
      <div className="container-app">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
              <Logo variant="light" size="xs" alt={appName} customLogoUrl={appLogoUrl} />
            </Link>
          </div>

          <nav className="flex items-center space-x-4">
            {/* My Library - Only visible to users with ReadBook permission */}
            {auth.isAuthenticated && hasReadPermission && (
              <Link
                to="/my-library"
                className="text-neutral-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
              >
                {t('App.Header.MyLibrary')}
              </Link>
            )}

            {/* Admin Menu - Only visible to users with admin access */}
            {auth.isAuthenticated && <AdminMenu />}

            <LanguagePicker />
            <InstallButton />

            {/* Auth buttons - mobile-friendly (44x44px min touch target) */}
            {auth.isAuthenticated ? (
              <div className="flex items-center space-x-3">
                <span className="text-sm text-neutral-600 hidden sm:inline">
                  {auth.user?.profile?.email || auth.user?.profile?.name || 'User'}
                </span>
                <button
                  onClick={handleLogout}
                  className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors min-h-[44px]"
                >
                  {t('App.Header.Logout')}
                </button>
              </div>
            ) : (
              <button
                onClick={handleLogin}
                className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors min-h-[44px]"
              >
                {t('App.Header.Login')}
              </button>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}
